module.exports = __webpack_public_path__ + "assets/images/03_thumb_9fef63650e60fa139a038871ecb879e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/03_thumb.png
// module id = 123
// module chunks = 0